<app-admin-list-page [title]="'Tags' | translate">

  <button slot="actions" class="btn btn-primary" (click)="addTag()">
    {{'Add' | translate}}
  </button>

  <app-table [config]="configTable" (buttonEvent)="handleButtonEvent($event)"></app-table>

</app-admin-list-page>
